<div class=" " *ngIf="showRequest">
  <h2 class="sectionTitle" *ngIf="!IsReadOnly">{{ 'FRONT_USER.ADMIN_DECISION_FORM.ADMIN_DECISION' | translate }}</h2>

  <!--load shipyard request read only-->
  <div *ngIf="baseRequestDTO" class="read-only-content">
    <!--request Details summary-->
    <!-- <app-request-details [baseRequest]="baseRequestDTO"></app-request-details> -->
    <!--request -->

    <div *ngIf="baseRequestDTO.ServiceId==serviceType.Repair">
      <app-create-repair-request></app-create-repair-request>
    </div>
    <div *ngIf="baseRequestDTO.ServiceId==serviceType.NonDestructiveTestingWork">
      <app-non-destructive-testing-work></app-non-destructive-testing-work>
    </div>
    <div *ngIf="baseRequestDTO.ServiceId==serviceType.HardnessTest">
      <app-create-hardness-test-request></app-create-hardness-test-request>
    </div>
    <div *ngIf="baseRequestDTO.ServiceId==serviceType.DynamicBalancing">
      <app-dynamic-balancing-request></app-dynamic-balancing-request>
    </div>
    <div *ngIf="baseRequestDTO.ServiceId==serviceType.FloatingCranes">
      <app-create-floating-cranes-request></app-create-floating-cranes-request>
    </div>
    <div *ngIf="baseRequestDTO.ServiceId==serviceType.FiberGlass">
      <app-fibberglass-request></app-fibberglass-request>
    </div>
    <div *ngIf="baseRequestDTO.ServiceId==serviceType.Salvage">
      <app-salvage-request></app-salvage-request>
    </div>

  </div>
  <!-- Admin Decision -->
  <div [class.read-only-content]="IsReadOnly" class="read-only-content" >
    <!-- Title -->
    <div class="form-container">
      <h4 class="section-title">{{ 'FRONT_USER.ADMIN_DECISION_FORM.ADMIN_DECISION' | translate }}</h4>
      <!-- load shipyard request Department name read only -->
      <div class="form-group" *ngIf="baseRequestDTO">
        <label for="ServiceId">{{ 'FRONT_USER.ADMIN_DECISION_FORM.DEPARTMENT' | translate}}</label>
        <div *ngIf="displayedLang=='NameEN'">
          <input type="text" class="form-control" id="ServiceId" name="ServiceId"
            [(ngModel)]="baseRequestDTO.Service.NameEN" [disabled]="true" />
        </div>
        <div *ngIf="displayedLang=='NameAR'">
          <input type="text" class="form-control" id="ServiceId" name="ServiceId"
            [(ngModel)]="baseRequestDTO.Service.NameAR" [disabled]="true" />
        </div>
      </div>
      <!-- Date -->
      <div class="form-group">
        <label>{{'FRONT_USER.ADMIN_DECISION_FORM.DATE'|translate}}</label>
        <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker
          value="{{currentDate| date: 'dd/MM/yyyy'}}" [disabled]="true" [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD' }">
      </div>
    </div>
    <form [formGroup]="adminDecisionForm" >

      <!-- Decision -->
      <fieldset [disabled]="IsReadOnly">
        <div class="form-group">
          <label >
            {{ 'FRONT_USER.ADMIN_DECISION_FORM.DECISION' | translate }}</label>
          <span class="red">
            *</span>
          <div class="form-custom-inputs">
            <div *ngFor="let decisions of decisionKeys;let i='index'" class="custom-Radio">
              <input type="radio" [id]=[decisions] (change)="changeDecision(decision[decisions])"  name="Decision"
                 [value]="decision[decisions]" formControlName="Decision" />

              <label [for]="[decisions]">{{ 'FRONT_USER.ADMIN_DECISION_FORM.' + decisions | translate }}</label>
            </div>
          </div>

          <div *ngIf="submitted && f.Decision?.errors" class="red ">
            <div *ngIf="f.Decision?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>

          </div>
        </div>
      </fieldset>

      <!-- Accept Decision If Request Is not A fiberglass -->
      <div *ngIf="testedDiv==decision.Accept && baseRequestDTO.ServiceId != serviceType.FiberGlass">
        <fieldset [disabled]="IsReadOnly">
          <div class="form-container">

            <!-- RequiredDays -->
            <div class="form-group">
              <label for="RequiredDays">{{ 'FRONT_USER.ADMIN_DECISION_FORM.REQUIRED_DAYS' | translate}}</label>

              <input type="text" class="form-control" id="RequiredDays" name="RequiredDays"
                formControlName="RequiredDays" />
              <!-- <div *ngIf="submitted ||( f.RequiredDays?.errors&& f.RequiredDays?.dirty )" class="red">

               <div *ngIf="f.RequiredDays?.errors?.pattern">{{'FRONT_USER.greaterThanZero' | translate}}</div>
              </div> -->
            </div>

            <!-- NearestAvailableTime -->
            <div class="form-group"
              *ngIf="baseRequestDTO.ServiceId == serviceType.DynamicBalancing || baseRequestDTO.ServiceId == serviceType.HardnessTest || baseRequestDTO.ServiceId == serviceType.NonDestructiveTestingWork">
              <label>{{'FRONT_USER.ADMIN_DECISION_FORM.NEAREST_AVAILABLE_TIME'|translate}}</label>
              <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker
                formControlName="NearestAvailableTime" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }" >

            </div>
            <!-- ServiceCost -->
            <div class="form-group">
              <label for="ServiceCost">{{ 'FRONT_USER.ADMIN_DECISION_FORM.SERVICE_COST' | translate}}</label>
              <span class="red"> *</span>
              <div class="input-group">
                <input type="text" class="form-control" id="ServiceCost" name="ServiceCost"
                  formControlName="ServiceCost" appOnlyDecimal  [onlydecimal]="true" />
                <span class="input-group-addon">{{ 'FRONT_USER.SIGNDOLLAR' | translate}}</span>
              </div>
              <div class="upload-info">
                <span>{{'FRONT_USER.ADMIN_DECISION_FORM.NOTE' | translate}}</span>
              </div>
              <div *ngIf="submitted ||(f.ServiceCost?.errors&& f.ServiceCost?.dirty)" class="red">
                <div *ngIf="f.ServiceCost?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                 <!-- <div *ngIf="f.ServiceCost?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div> -->
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <!-- Accept Decision If Request Is A fiberglass -->
      <div *ngIf="testedDiv==decision.Accept && baseRequestDTO.ServiceId == serviceType.FiberGlass">
        <fieldset [disabled]="IsReadOnly">
          <div class="form-container">

            <!-- RequiredDays -->
            <div class="form-group">
              <label for="RequiredDays">{{ 'FRONT_USER.ADMIN_DECISION_FORM.REQUIRED_DAYS' | translate}}</label>
              <input type="text" class="form-control" id="RequiredDays" name="RequiredDays"
                formControlName="RequiredDays" />
              <!-- <div *ngIf="submitted ||( f.RequiredDays?.errors&& f.RequiredDays?.dirty )" class="red">

                <div *ngIf="f.RequiredDays?.errors?.pattern">{{'FRONT_USER.greaterThanZero' | translate}}</div>
              </div> -->
            </div>

            <!-- ServiceCost -->
            <div class="form-group">
              <label for="ServiceCost">{{ 'FRONT_USER.ADMIN_DECISION_FORM.SERVICE_COST' | translate}}</label>
              <span class="red"> *</span>
              <div class="input-group">
                <input type="text" class="form-control" id="ServiceCost" name="ServiceCost"
                  formControlName="ServiceCost" appOnlyDecimal [onlydecimal]="true"  />
                <span class="input-group-addon">{{ 'FRONT_USER.SIGNDOLLAR' | translate}}</span>
              </div>
              <div *ngIf="submitted ||(f.ServiceCost?.errors&& f.ServiceCost?.dirty)" class="red ">
                <div *ngIf="f.ServiceCost?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
          <!-- <div *ngIf="f.ServiceCost?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div> -->

              </div>
            </div>

            <!-- TechnicalAndFinantialOffer -->
            <div class="form-group" *ngIf="!IsReadOnly">
              <label>{{'FRONT_USER.ADMIN_DECISION_FORM.TECHNICAL_AND_FINANTIAL_OFFER'|translate}}</label>
              <span class="red">*</span>

              <input type="file" class="form-control" MaxSizeInMB="5"
                accept=".pdf,.gif, .jpg, .jpeg,.png,.bmp,.doc,.docx" id="ShipPhotoInput"
                formControlName="TechnicalAndFinantialOffer"
                (change)="onFileSelected($event,f.TechnicalAndFinantialOffer,'TechnicalAndFinantialOffer',14,'TechnicalProgress','FRONT_USER.ADMIN_DECISION_FORM.TECHNICAL_AND_FINANTIAL_OFFER')" />
              <div class="upload-info">
                <span>{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
                <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
              </div>
              <br>
              <div class="progress">
                <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
                  [style.width]="TechnicalProgress + '%'">
                  <span class=""> {{TechnicalProgress}} % Complete</span>
                </div>
              </div>
              <div *ngIf="submitted && f.TechnicalAndFinantialOffer?.errors" class="red">
                {{'FRONT_USER.This_Field_Is_Required' | translate}}

              </div>
            </div>



            <!-- TechnicalAndFinantialOffer In View Mode -->
            <div class="form-group" *ngIf="IsReadOnly">
                <div id="attachmentsUrls"  class=" read-uploaded">
              <label>{{ 'FRONT_USER.ADMIN_DECISION_FORM.TECHNICAL_AND_FINANTIAL_OFFER' | translate}}</label>
              <div>
                <a [attr.href]="TechnicalAndFinantialOfferURL" target="_blank">
                    <i class="icon-view-file"></i>
                    {{ 'FRONT_USER.REPAIR_REQUEST_FORM.VIEW' | translate}}
                  </a>
              </div>
              </div>
            </div>

            <!-- ValidDate -->
            <div class="form-group">
              <label>{{'FRONT_USER.ADMIN_DECISION_FORM.OFFER_VALID_UNTIL_DATE'|translate}}</label>
              <span class="red"> *</span>
              <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="ValidDate"
                [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY' }">
              <div *ngIf="submitted && f.ValidDate?.errors" class="red ">
                <div *ngIf="f.ValidDate?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>

              </div>
            </div>

            <!-- Remarks -->
            <div class="form-group">
              <label for="Remarks">{{ 'FRONT_USER.ADMIN_DECISION_FORM.REMARKS' | translate}}</label>
              <!-- <span class="red"> *</span> -->
              <textarea class="form-control" id="Remarks" name="Remarks" formControlName="Remarks"
                style="height: 186px;  width: 400px;"></textarea>
              <div *ngIf="submitted && f.Remarks?.errors" class="red ">
                <!-- <div *ngIf="f.Remarks?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div> -->
                <div *ngIf="f.Remarks?.errors?.maxlength">{{'FRONT_USER.MAX_LENGTH_ERROR' | translate}}</div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <!-- Reject Decision -->
      <div *ngIf="testedDiv == decision.Reject">
        <fieldset [disabled]="IsReadOnly">
          <div class="form-container">

            <!-- RejectionReasons -->
            <div class="form-group">
              <label for="RejectionReasons">{{ 'FRONT_USER.ADMIN_DECISION_FORM.REJECT_REASONS' | translate}}</label>
              <span class="red"> *</span>
              <textarea class="form-control" id="RejectionReasons" name="RejectionReasons"
                formControlName="RejectionReasons" style="height: 186px;  width: 400px;"></textarea>
              <div *ngIf="submitted && f.RejectionReasons?.errors" class="red ">
                <div *ngIf="f.RejectionReasons?.errors?.required">
                  {{'FRONT_USER.This_Field_Is_Required' | translate}}
                </div>
                <div *ngIf="f.RejectionReasons?.errors?.maxlength">{{'FRONT_USER.MAX_LENGTH_ERROR' | translate}}</div>
              </div>
            </div>

            <!-- Comments -->
            <div class="form-group">
              <label for="Comments">{{ 'FRONT_USER.ADMIN_DECISION_FORM.COMMENTS' | translate}}</label>
              <textarea class="form-control" id="Comments" name="Comments" formControlName="Comments"
                style="height: 186px;  width: 400px;"></textarea>
            </div>
            <div *ngIf="submitted && f.Comments?.errors" class="red ">
              <div *ngIf="f.Comments?.errors?.maxlength">
                {{'FRONT_USER.MAX_LENGTH_ERROR' | translate}}
              </div>
            </div>
          </div>
        </fieldset>
      </div>

      <!-- submit button -->
      <div class="form-group" *ngIf="!IsReadOnly">
        <button Confirmation (confirmationClick)="onSubmit()"  class="btn SCAcustomBtn">{{ 'FRONT_USER.SAVE' | translate}}</button>
      </div>

    </form>
  </div>
</div>



<!-- Confirmation -->
<div *ngIf="!showRequest&&!isErrorMessage&&!lockTaskErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p>{{ 'FRONT_USER.ADMIN_DECISION_FORM.ADMIN_SUCCESS_MESSAGE' | translate }}</p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">{{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>


<!-- error message -->
<div *ngIf="!showRequest&&isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>

    </div>
</div>

<!-- error message -->
<div *ngIf="!showRequest&&lockTaskErrorMessage" class="alert alert-warning" role="alert">
  <div class="alignC">
      <i class="icon-error"></i>
      <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
      <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>

  </div>
</div>


